import { alpha, darken, lighten, Theme } from "@mui/material";

const gridRowBackgroundColor = (theme: Theme) => {
  if (theme.palette.mode === "light") {
    return darken(alpha(theme.palette.background.default, 1), 0.06);
  }
  return lighten(alpha(theme.palette.background.default, 1), 0.06);
};

export { gridRowBackgroundColor };
